<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('admin-episode', true)">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Playlist</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            placeholder="Title"
            :rules="{ required: true }"
            v-model="episode_data.title"
            maxlength="200"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Video URL</p>
          <base-input
            alternative
            class="mb-3"
            name="Video URL"
            :rules="{ required: true }"
            placeholder="Video URL"
            v-model="episode_data.video_url"
          >
          </base-input>
        </div>
        <div>
          <p class="input-title text-black">Description</p>
          <base-input
            alternative
            class="mb-3"
            name="Description"
            :rules="{ required: true }"
            placeholder="Description"
            maxlength="800"
            v-model="episode_data.description"
          >
          </base-input>
        </div>

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      episodes: [],
      title: "",
      category: "",
      editorOption: {
        theme: "snow",
      },

      pageData: {},
      episode_data: {},
    };
  },
  computed: {
    ...mapState("playlist", {
      selectedEpisode: "selectedEpisode",
    }),
  },
  watch: {
    pageData(val) {
      this.episode_data = { ...val };
    },
  },
  methods: {
    removeField(index) {
      this.episode_data.episodes.splice(index, 1);
    },
    addField() {
      this.episode_data.episodes.push({ title: "", video_url: "" });
    },
    async onSubmit() {
      let payload = {
        episodeId: this.episode_data._id,
        title: this.episode_data.title,
        video_url: this.episode_data.video_url,
        description: this.episode_data.description,
      };

      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "playlist/update_episode",
          payload
        );
        // if (editData.code == 200) {
        this.handleClick("admin-episode", true);
        this.$swal.fire({
          text: "Your data has been successfully edited!",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        console.log(error);
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedEpisode;
    },
    handleClick(name, query = false) {
      if (query) {
        this.$router.push({
          name: name,
          query: {
            pid: this.$route.query.pid,
            cid: this.$route.query.cid,
          },
        });
      } else {
        this.$router.push({ name: name });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
